import Header from '@/components/Header';
import Footer from '@/components/Footer';

interface PagePlaceholderProps {
  title: string;
  subtitle?: string;
}

export default function PagePlaceholder({ title, subtitle }: PagePlaceholderProps) {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-background-50">
        <div className="pt-32 md:pt-40 pb-20 px-4 md:px-8 lg:px-12">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block text-xs font-mono font-medium text-accent-600 uppercase tracking-widest mb-4">
              Coming Soon
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-semibold text-foreground-950 leading-tight tracking-tight mb-4">
              {title}
            </h1>
            {subtitle && (
              <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto">
                {subtitle}
              </p>
            )}
            <div className="mt-12 flex justify-center">
              <div className="w-16 h-16 rounded-full bg-accent-100/50 flex items-center justify-center">
                <i className="ri-tools-line text-2xl text-accent-500" />
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}